export function Partnership() {
  const logos = require.context(
    "../assets/partners",
    false,
    /\.(png|jpe?g|svg)$/,
  );
  const logoPaths = logos.keys().map(logos);

  return (
    <section className="px-0 py-12 text-center bg-white hidden">
      <h2 className="mx-20 text-5xl tracking-tighter text-black max-sm:text-4xl">
        Our Partners
      </h2>
      <div className="flex flex-wrap justify-evenly items-center gap-10 mt-20 px-10">
        {logoPaths.map((logo, index) => (
          <img
            key={index}
            src={logo}
            alt={`Partner Logo ${index + 1}`}
            className="w-[33vh] max-w-[400px] object-contain py-5"
          />
        ))}
      </div>
    </section>
  );
}

export default Partnership;
